import plugin_vue3_A0OWXRrUgq from "/home/vsts/work/1/s/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.mjs";
import revive_payload_client_4sVQNw7RlN from "/home/vsts/work/1/s/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import components_plugin_KR1HBZs4kY from "/home/vsts/work/1/s/.nuxt/components.plugin.mjs";
import unhead_KgADcZ0jPj from "/home/vsts/work/1/s/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/home/vsts/work/1/s/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import prefetch_client_5tzzN0oIVL from "/home/vsts/work/1/s/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import plugin_eTVJQYlCmx from "/home/vsts/work/1/s/node_modules/@nuxtjs/apollo/dist/runtime/plugin.mjs";
import plugin_client_i8AMfKeYnY from "/home/vsts/work/1/s/node_modules/@nuxtjs/color-mode/dist/runtime/plugin.client.mjs";
import chunk_reload_client_UciE0i6zes from "/home/vsts/work/1/s/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import native_handlers_gvBySvcsi9 from "/home/vsts/work/1/s/plugins/native-handlers.ts";
import launchdarkly_CejpJ3q1Tn from "/home/vsts/work/1/s/plugins/launchdarkly.ts";
import analytics_SVnwK7EMrr from "/home/vsts/work/1/s/plugins/analytics.ts";
import sports_OUnmVSDa96 from "/home/vsts/work/1/s/plugins/sports.ts";
import banner_tag_F29Tjs1Urw from "/home/vsts/work/1/s/plugins/banner-tag.ts";
import plugin_1UohGbtF8v from "/home/vsts/work/1/s/node_modules/@pinia-plugin-persistedstate/nuxt/dist/runtime/plugin.mjs";
import apollo_js_baEmw5cyCJ from "/home/vsts/work/1/s/plugins/apollo.js.ts";
import dev_dashboard_vxXFhb2E9P from "/home/vsts/work/1/s/plugins/dev-dashboard.ts";
import init_client_lHDJZN4lq2 from "/home/vsts/work/1/s/plugins/init.client.ts";
import primevue_7rYYRZQLyx from "/home/vsts/work/1/s/plugins/primevue.ts";
import use_query_trU6nkMqlZ from "/home/vsts/work/1/s/plugins/use-query.ts";
import vertical_bridge_client_yrIlPI5SRU from "/home/vsts/work/1/s/plugins/vertical-bridge.client.ts";
export default [
  plugin_vue3_A0OWXRrUgq,
  revive_payload_client_4sVQNw7RlN,
  components_plugin_KR1HBZs4kY,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  prefetch_client_5tzzN0oIVL,
  plugin_eTVJQYlCmx,
  plugin_client_i8AMfKeYnY,
  chunk_reload_client_UciE0i6zes,
  native_handlers_gvBySvcsi9,
  launchdarkly_CejpJ3q1Tn,
  analytics_SVnwK7EMrr,
  sports_OUnmVSDa96,
  banner_tag_F29Tjs1Urw,
  plugin_1UohGbtF8v,
  apollo_js_baEmw5cyCJ,
  dev_dashboard_vxXFhb2E9P,
  init_client_lHDJZN4lq2,
  primevue_7rYYRZQLyx,
  use_query_trU6nkMqlZ,
  vertical_bridge_client_yrIlPI5SRU
]